module.exports = __webpack_public_path__ + "img/ico_error_content.506f1a58.svg";